const map = {
	"./en.vue": [
		10048,
		[
			48
		]
	],
	"./lt.vue": [
		78074,
		[
			8074
		]
	],
	"./lv.vue": [
		98354,
		[
			8354
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 36372;
module.exports = webpackAsyncContext;